<template>
  <div class="map-window">
    <slot />
  </div>
</template>
